<div class="cancel-transport-dialog">

  <div class="dialog-layout">

    <h2 class="dialog-h2">
      {{'cancel transport' | translate: ['tmc-yard.widgets.sac-client.cancel-transport-dialog.title', translationService.language]}}
    </h2>

    <div class="top-info">
      <app-transport-info-panel [carrier]="data.carrier" [identifier]="data.identifier" [driver]="data.driver"
        [scope]="data.transportScope"></app-transport-info-panel>
    </div>

    <div class="dialog-content cancel-transport-content">

      <mat-radio-group [(ngModel)]="selectedViewMode" class="view-modes">
        <mat-radio-button class="margin-right-15" value="{{viewModeRepeatProcessing}}">
          {{'repeat processing' | translate: ['tmc-yard.widgets.sac-client.cancel-transport-dialog.mode.repeat-processing', translationService.language]}}
        </mat-radio-button>
        <mat-radio-button value="{{viewModeForwardTransport}}">
          {{'forward to station' | translate: ['tmc-yard.widgets.sac-client.cancel-transport-dialog.mode.forward-transport', translationService.language]}}
        </mat-radio-button>
      </mat-radio-group>

      <div class="repeating" [hidden]="selectedViewMode !== viewModeRepeatProcessing" [formGroup]="formGroup">
        <sc-content-spacer [vertical]="true"></sc-content-spacer>
        <sc-string-field [label]="'cancellation reason' | translate: ['tmc-yard.widgets.sac-client.cancel-transport-dialog.cancellation-reason', translationService.language]"
        formControlName="reason"></sc-string-field>
        <sc-sub-title>
          {{'destination station' | translate: ['tmc-yard.widgets.sac-client.cancel-transport-dialog.destination-station', translationService.language]}}
        </sc-sub-title>
        <sc-content-spacer [vertical]="true"></sc-content-spacer>
        <mat-radio-group class="station-selection" aria-label="Select an option" [(ngModel)]="selectedStationForRepeat"
          [ngModelOptions]="{standalone: true}">
          <mat-radio-button class="option" [value]="station" *ngFor="let station of data.stationForRepeatProcessing">
            {{station.title}}
          </mat-radio-button>
        </mat-radio-group>
      </div>

      <div class="forwarding" [hidden]="selectedViewMode !== viewModeForwardTransport">
        <div class="inline-flex">
          <app-dictionary-key-select (selectionChanged)="forwardingOptionsChanged($event)" class="forwarding-cause"
            [required]="configurationService.isRequired('ui-component.station-assignment-client.cancel-transport-dialog.forwarding-cause.required', true)"
            placeholder="{{'forwarding cause' | translate: ['tmc-yard.widgets.sac-client.cancel-transport-dialog.forwarding-cause-selection.title', translationService.language]}}"
            [rootKey]="'lookup.forwarding-cause.options'">
          </app-dictionary-key-select>
        </div>
        <app-station-selection [stationGroups]="this.data.stationForForwarding" [includeStations]="true"
          [includeWaitingareas]="false" [requiredSelectionLevels]="requiredSelectionLevels"
          (selectionChanged)="onForwardingStationSelectionChanged($event)">
        </app-station-selection>
      </div>
    </div>

    <div class="messages">
      <app-service-response [responseMessages]="responseMessages"></app-service-response>
    </div>
    <sc-actionbar>
      <sc-content-spacer [grow]="true"></sc-content-spacer>
      <button mat-stroked-button class="cancel-button" (click)="cancelDialog()"
        [disabled]="isCancelDisabled()">{{'cancel' | translate:['shared.selection-dialog.action.cancel', translationService.language]}}</button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-flat-button (click)="confirm()" class="confirm-button"
        [disabled]="isConfirmDisabled()">{{'confirm' | translate:['tmc-yard.widgets.sac-client.cancel-transport-dialog.action.confirm', translationService.language]}}</button>
    </sc-actionbar>
  </div>
</div>
